/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEvePriceCalculatorViewProps } from './eve-price-calculator';

export default (props: IEvePriceCalculatorViewProps) => {
    const { className, form, results, heading, helpText } = props;
    return (
        <div className={`${className}`}>
            {heading}
            {helpText}
            <div className={`${className}-display`}>
                {form}
                {results}
            </div>
        </div>
    );
};
